export default {"src":"/_next/static/media/500-dark.d7512151.svg","height":1000,"width":729,"blurWidth":0,"blurHeight":0};